/**
 * Component: Slider Page - Modal
 * ------------------------------------------------------------------------------
 * An interface to create carousel objects using the Swiper plugin.
 * - https://github.com/nolimits4web/swiper
 *
 * @namespace SliderPageModal
 */
import cssClasses from '../helpers/cssClasses';
import {on} from '../helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  designer: '[js-slider-page="designer"]',
  main: '[js-slider-page="main"]',
  modal: '[js-slider-page="modal"]',
  modalClose: '[js-modal="closeModal"]',
  modalContent: '[js-slider-page="modal-content"]',
  modalImage: '[js-slider-page="modal-image"]',
};

export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    main: document.querySelector(selectors.main),
    modal: document.querySelector(selectors.modal),
    modalClose: document.querySelector(selectors.modalClose),
    modalContent: document.querySelector(selectors.modalContent),
    modalImage: document.querySelector(selectors.modalImage),
  };

  /**
   * Modal click events.
   */
  function modalClickEvents() {
    on('click', nodeSelectors.main, (event) => {
      const target = event.target;

      if (!(target && target.matches(selectors.designer))) { return; }
      modalOpenFunction(target);
    });

    on('keyup', nodeSelectors.main, (event) => {
      if (event.keyCode !== 13) { return; }
      const target = event.target;

      if (!(target && target.matches(selectors.designer))) { return; }
      modalOpenFunction(target);
    });

    on('click', nodeSelectors.modal, (event) => {
      const target = event.target;

      if ((target && (target.matches('.modal__card') ||
        target.matches('.modal__body')))) { return; }

      modalCloseFunction();
    });

    on('click', nodeSelectors.modalClose, () => {
      modalCloseFunction();
    });

    on('keyup', (event) => {
      if (event.which !== 27) { return; }
      modalCloseFunction();
    });
  }

  /**
   * Modal open function.
   */
  function modalOpenFunction(target) {
    nodeSelectors.modal.classList.add(cssClasses.active);
    nodeSelectors.modal.focus();
    document.body.style.overflow = 'hidden';
    populateModal(target);
  }

  /**
   * Modal close function.
   */
  function modalCloseFunction() {
    nodeSelectors.modal.classList.remove(cssClasses.active);
    document.body.style.overflow = 'visible';

    setTimeout(() => {
      nodeSelectors.modalImage.style.backgroundImage = '';
      nodeSelectors.modalContent.innerHTML = '';
    }, 500);
  }

  /**
   * Populate modal.
   */
  function populateModal(target) {
    const designerName = target.innerText;
    let description = '';
    let image = '';
    let name = '';

    window.theme.designers.forEach((designer) => {
      if (designer.name !== designerName) { return; }
      name = `<h3>${designer.name}</h3>`;
      description = `<div class="body-2">${designer.description}</div>`;
      image = designer.image;
    });

    nodeSelectors.modalContent.innerHTML = `${name} ${description}`;
    nodeSelectors.modalImage.style.backgroundImage = `url('${image}')`;
  }

  /**
   * Initialise components.
   */
  function init() {
    modalClickEvents();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
